<template>
  <router-link :class="`${isLast ? '' : ' list-button-margin'}`" v-if="to.name" :to="to">
    <el-button :class="`list-button list-button-${size}`" :icon="`icon icon-${icon}`" size="small" plain>{{name}}</el-button>
  </router-link>

  <el-button
    :class="`list-button list-button-${size}${isLast ? '' : ' list-button-margin'}`"
    v-else
    :icon="`icon icon-${isLoading ? 'loading' : icon}`"
    size="small"
    @click="handleClick"
    plain
  >{{name}}</el-button>
</template>

<script>
import message from "@/utils/message";

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'edit',
    },
    name: {
      type: String,
      default: '修改',
    },
    to: {
      type: Object,
      default: () => ({}),
    },
    message: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'small',
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async handleClick() {
      if (this.isLoading) return;

      if (this.message) {
        const isCancel = await message({ message: this.message });
        if (isCancel) return;
      }

      this.$emit('click');
    },
  },
};
</script>

<style scoped>
.list-button-margin {
  margin-right: .5vw;
}

.list-button {
  font-size: 14px;
}

.list-button-small {
  width: 3.3vw;
}

.list-button-large {
  width: 112px;
}

.list-button-wide {
  width: 150px;
}


@media screen and (min-width:1921px) {

}

@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .list-button-small {
    width: 4.2vw;
  }
}
@media screen and (min-width: 960px) and (max-width: 1199px) {

}
@media screen and (min-width: 768px) and (max-width: 959px) {

}
@media only screen and (min-width: 480px) and (max-width: 767px){

}
@media only screen and (max-width: 479px) {
  .list-button-small {
    width: 20vw;
    height: 8vw!important;
  }

  .list-button-wide {
    width: 46vw;
    height: 8vw!important;
  }

  .list-button-margin {
    margin-right: 2vw;
  }
}



>>>.icon {
  margin-right: 6px;
}

.el-button {
  height: 32px;
  padding: 0;
  margin-left: 0;
}
</style>
